import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import LandingPage from './pages/landing-page';
import ProjectPortfolio from './pages/project-portfolio';
import ReferralNetwork from './pages/referral-network';
import UserDashboard from './pages/user-dashboard';
import InteractiveFloorPlans from './pages/interactive-floor-plans';
import CRMLeadManagement from './pages/crm-lead-management';
import AdminFloorPlanEditor from './pages/admin-floor-plan-editor';
import AdminDashboard from './pages/admin-dashboard';
import SignIn from './pages/auth/SignIn';
import SignUp from './pages/auth/SignUp';
import AdminSignUp from './pages/auth/AdminSignUp';
import AuthCallback from './pages/auth-callback';
import SocialMediaMarketingHub from './pages/social-media-marketing-hub';
import SecurityConnectionManagement from './pages/security-connection-management';
import LeadDataManagementImportCenter from './pages/lead-data-management-import-center';
import DynamicPipelineConfigurationCenter from './pages/dynamic-pipeline-configuration-center';
import RealTimeNotificationCommunicationHub from './pages/real-time-notification-communication-hub';
import AdvancedAnalyticsDashboard from './pages/advanced-analytics-custom-dashboard-builder';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/admin-signup" element={<AdminSignUp />} />
        <Route path="/auth-callback" element={<AuthCallback />} />
        <Route path="/project-portfolio" element={<ProjectPortfolio />} />
        <Route path="/interactive-floor-plans" element={<InteractiveFloorPlans />} />
        
        {/* Protected Routes - Require Authentication */}
        <Route 
          path="/user-dashboard" 
          element={
            <ProtectedRoute requireAdvisor>
              <UserDashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin-dashboard" 
          element={
            <ProtectedRoute requireAdmin>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/crm-lead-management" 
          element={
            <ProtectedRoute requireAdvisor>
              <CRMLeadManagement />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/referral-network" 
          element={
            <ProtectedRoute requireAdvisor>
              <ReferralNetwork />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin-floor-plan-editor" 
          element={
            <ProtectedRoute requireAdmin>
              <AdminFloorPlanEditor />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/social-media-marketing-hub" 
          element={
            <ProtectedRoute requireAdvisor>
              <SocialMediaMarketingHub />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/security-connection-management" 
          element={
            <ProtectedRoute requireAdmin>
              <SecurityConnectionManagement />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/advanced-analytics-custom-dashboard-builder" 
          element={
            <ProtectedRoute requireAdmin>
              <AdvancedAnalyticsDashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/lead-data-management-import-center" 
          element={
            <ProtectedRoute requireAdmin>
              <LeadDataManagementImportCenter />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/dynamic-pipeline-configuration-center" 
          element={
            <ProtectedRoute requireAdmin>
              <DynamicPipelineConfigurationCenter />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/real-time-notification-communication-hub" 
          element={
            <ProtectedRoute requireAdmin>
              <RealTimeNotificationCommunicationHub />
            </ProtectedRoute>
          } 
        />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
